// import NextLink from 'next/link';
// import { useRouter } from 'next/router';
import { useHistory, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types';
import { Box, Button, ListItem } from '@mui/material';

export const NavItem = (props) => {
  const { href, icon, title, ...others } = props;
  // const router = useRouter();
  const history = useHistory();
  const location = useLocation();
  // const active = href ? (location.pathname === href) : false;
  const active = (!props.disabled && href) ? (location.pathname === href) : false;

  return (
    <ListItem
      disableGutters
      sx={{
        display: 'flex',
        mb: 0.5,
        py: 0,
        px: 2
      }}
      {...others}
    >
      {/* <NextLink
        href={href}
        passHref
      > */}
        <Button
          onClick={() => history.push(href)}
          component="a"
          startIcon={icon}
          disabled={props.disabled}
          disableRipple
          sx={{
            backgroundColor: active && 'rgba(255,255,255, 0.08)',
            borderRadius: 1,
            color: active ? 'primary.light' : 'neutral.300',
            fontWeight: active && 'fontWeightBold',
            justifyContent: 'flex-start',
            px: 3,
            textAlign: 'left',
            textTransform: 'none',
            width: '100%',
            '& .MuiButton-startIcon': {
              color: active ? 'primary.light' : 'neutral.400'
            },
            '&:hover': {
              backgroundColor: 'rgba(255,255,255, 0.08)'
            },
            '&.Mui-disabled': {
              color: 'neutral.300',
              opacity: 1, // Optional: prevents MUI from reducing opacity
              // '& .MuiButton-startIcon': {
              //   color: 'primary.light'
              // }
            }
          }}
        >
          <Box sx={{ flexGrow: 1 }}>
            {title}
          </Box>
        </Button>
      {/* </NextLink> */}
    </ListItem>
  );
};

NavItem.propTypes = {
  href: PropTypes.string,
  icon: PropTypes.node,
  title: PropTypes.string
};
